import script from "./CSearchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSearchInput.vue?vue&type=script&setup=true&lang=ts"

import "./CSearchInput.vue?vue&type=style&index=0&id=c81de486&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c81de486"]])

export default __exports__